import { Component, OnInit } from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {RoomService} from "../../services/room.service";
import {Router} from "@angular/router";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {User, UserService} from "../../services/user.service";
import { FooterComponent } from '../../components/footer/footer.component';
import { MenuBarComponent } from '../../components/menu-bar/menu-bar.component';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { IotService } from 'src/app/services/iot.service';
import { Hub } from 'aws-amplify/utils';
import { CONNECTION_STATE_CHANGE, ConnectionState } from '@aws-amplify/pubsub';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: true,
    imports: [NavbarComponent, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatButtonModule, NgIf, MenuBarComponent, FooterComponent]
})
export class HomeComponent implements OnInit {

  user?: User ;

  checkingRoom: boolean = false ;

  roomCodeControl = new FormControl('');

  constructor(
    private users: UserService,
    private rooms: RoomService,
    private router: Router,
    private iot: IotService
  ) { }

  async ngOnInit()  {

    Hub.listen('pubsub', (data: any) => {
      
      const { payload } = data;
      if (payload.event === CONNECTION_STATE_CHANGE) {
        //const connectionState = payload.data.connectionState as ConnectionState;
        console.log(payload);
      }
    });

    try {
      this.user = await firstValueFrom(this.users.getUser()) ;
    } catch(e) {

    }
    
    try {
      this.iot.getClient().subscribe({ topics: 'testing' }).subscribe({
        next: (data) => console.log('Message received', data),
        error: (error) => console.error(error),
        complete: () => console.log('Done')
      });
    } catch(e) {

    }

  }

  async checkCode() {

    this.checkingRoom = true ;

    let roomAvailable = false ;

    let room = null ;
    try {
      room = await firstValueFrom(this.rooms.getRoom(this.roomCodeControl.value!)) ;

      if (room) {
        if (room.status != 'ACTIVE') {
          this.roomCodeControl.setErrors({ inactiveRoom: true });
        } else {
          roomAvailable = true ;
        }
      } else {
        this.roomCodeControl.setErrors({ noRoom: true });
      }
    }
    catch (e) {
      console.log(e);
      this.roomCodeControl.setErrors({ noRoom: true });
    }

    this.checkingRoom = false ;
    this.roomCodeControl.markAsTouched();

    if (roomAvailable) {
      await this.router.navigate(['join', room!.id]) ;
    }
  }

}
